"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileBodyContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Gallery = require("b2b-components/core/components/Gallery");
var _MobileBody = require("./MobileBody");
const MobileBodyContainer = _ref => {
  let {
    image360 = null,
    images = null,
    videos = null,
    ...originalProps
  } = _ref;
  const {
    currentItemType,
    totalImage360Count,
    totalImageCount,
    totalVideoCount
  } = originalProps;
  const mobileImage360 = currentItemType === _Gallery.GALLERY_ITEM_TYPE.image360 ? image360 : null;
  const mobileImages = currentItemType === _Gallery.GALLERY_ITEM_TYPE.image ? images : null;
  const mobileVideos = currentItemType === _Gallery.GALLERY_ITEM_TYPE.video ? videos : null;
  let mobileItemIndexArray = [];
  switch (currentItemType) {
    case _Gallery.GALLERY_ITEM_TYPE.image:
      mobileItemIndexArray = Array.from(Array(totalImageCount).keys());
      break;
    case _Gallery.GALLERY_ITEM_TYPE.image360:
      mobileItemIndexArray = [totalImageCount];
      break;
    case _Gallery.GALLERY_ITEM_TYPE.video:
      mobileItemIndexArray = Array.from(Array(totalVideoCount).keys()).map(index => index + totalImageCount + totalImage360Count);
      break;
  }
  return /*#__PURE__*/_react.default.createElement(_MobileBody.MobileBody, (0, _extends2.default)({}, originalProps, {
    image360: mobileImage360,
    images: mobileImages,
    itemIndexArray: mobileItemIndexArray,
    videos: mobileVideos
  }));
};
exports.MobileBodyContainer = MobileBodyContainer;
//# sourceMappingURL=MobileBodyContainer.js.map